<div class="p-grid account-root">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Account</label>
  </div>
  <div class="p-col-12 p-md-8 p-lg-8">
    <p-dropdown *ngIf="rootAccountsDropdown"
                name="selectCodeType" [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{ 'overflow': 'visible'}"
                [options]="rootAccountsDropdown" [filter]="true"
                [(ngModel)]="rootAccount" (onChange)="onSelectRootAccount(rootAccount)"></p-dropdown>
  </div>
</div>

<div *ngIf="rootAccount?.id" class="p-grid">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Sub Account
      <button pButton type="button" class="icon-action" icon="fa fa-th-list" (click)="op.show($event)"></button>
    </label>
  </div>
  <div class="p-col-12 p-md-8 p-lg-8">
    <input pInputText name="account.accountName" type="text"
           [ngModel]="legerAccount ? legerAccount.accountNumber+':'+legerAccount.accountName:''" readonly="true">
  </div>
</div>

<p-overlayPanel [style]="{'max-height':'350px','width':'375px'}" #op [dismissable]="true" [showCloseIcon]="true" [styleClass]="'add-account-overlay'">
  <p-tree [value]="accountsTreeNodes" [style]="{ 'overflow-y':'scroll','overflow-x':'hidden','max-height':'325px','width':'355px'}"
          selectionMode="single" [(selection)]="accountNode"
          [styleClass]="'tree-container'"
          (onNodeSelect)="onSelectAccountNode(accountNode?.data, true, op)">
  </p-tree>
</p-overlayPanel>
